import { render, staticRenderFns } from "./addInterestGroup.vue?vue&type=template&id=39243a88&scoped=true"
import script from "./addInterestGroup.vue?vue&type=script&lang=js"
export * from "./addInterestGroup.vue?vue&type=script&lang=js"
import style0 from "./addInterestGroup.vue?vue&type=style&index=0&id=39243a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39243a88",
  null
  
)

export default component.exports